"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementProps = void 0;

var useElementProps = function useElementProps(element) {
  if (!element || !element.current) return {
    left: 0,
    top: 0,
    bottom: 0,
    height: 0,
    width: 0
  };
  var current = element.current;

  var _current$getBoundingC = current.getBoundingClientRect(),
      left = _current$getBoundingC.left,
      top = _current$getBoundingC.top,
      bottom = _current$getBoundingC.bottom,
      height = _current$getBoundingC.height,
      width = _current$getBoundingC.width;

  var docEl = document.documentElement;
  return {
    left: left + (window.pageXOffset || docEl.scrollLeft || 0),
    top: top + (window.pageYOffset || docEl.scrollTop || 0),
    bottom: bottom + (window.pageYOffset || docEl.scrollTop || 0),
    height: height,
    width: width
  };
};

exports.useElementProps = useElementProps;